import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _CopyAltLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M15 3H9a4 4 0 0 0-4 4v8" }),
            React.createElement("path", { stroke: "currentColor", d: "M13.5 6.5c1.184 0 2.03 0 2.684.074.642.073 1.035.21 1.337.443q.262.2.462.462c.232.302.37.695.443 1.337.073.653.074 1.5.074 2.684v4c0 1.184 0 2.03-.074 2.684-.073.642-.21 1.035-.443 1.337a2.5 2.5 0 0 1-.462.462c-.302.232-.695.37-1.337.443-.653.073-1.5.074-2.684.074s-2.03 0-2.684-.074c-.642-.073-1.035-.21-1.337-.443a2.5 2.5 0 0 1-.462-.462c-.232-.302-.37-.695-.443-1.337-.073-.653-.074-1.5-.074-2.684v-4c0-1.184 0-2.03.074-2.684.073-.642.21-1.035.443-1.337q.2-.263.462-.462c.302-.232.695-.37 1.337-.443.653-.073 1.5-.074 2.684-.074Z" })));
}
const CopyAltLight = forwardRef(_CopyAltLight);
export { CopyAltLight };
